//jshint module : true
import actionTypes from './action-types';
import pick from 'underscore/modules/pick';

export default (
    state = {
        isTcfLoaded: false,
        gpt: null,
        adSenseQuery: null,
        adSenseShoppingPublisherId:
            process.env.PUBLIC_ADSENSE_SHOPPING_PUBLISHER_ID
    },
    action
) => {
    switch (action.type) {
        case actionTypes.INITIALIZE:
            return {
                ...action.payload
            };
        case actionTypes.SET_ADS:
            if (!action || !action.type || !action.payload) return state;
            return {
                ...state,
                gpt: action.payload.gpt,
                adSenseQuery: action.payload.adSenseQuery
                    ? action.payload.adSenseQuery
                    : null,
                adSenseShoppingPublisherId:
                    action.payload.adSenseShoppingPublisherId
            };
        case actionTypes.SET_GPT: {
            const {
                adUnitPath,
                age,
                devTest,
                gender,
                memberIdHash,
                page
            } = action.payload;
            return {
                ...state,
                gpt: {
                    adUnitPath,
                    customTargetingParameters: pick(
                        {
                            page,
                            gender,
                            age,
                            devTest
                        },
                        Boolean
                    ),
                    publisherProvidedId: memberIdHash
                }
            };
        }
        case actionTypes.SET_TCF_LOADED:
            return {
                ...state,
                isTcfLoaded: true
            };

        default:
            return state;
    }
};
